module.exports = __webpack_public_path__ + "media/images/design/images/dantai/btn_dandan-2c4c6c8ce8e056b758c73047ecc9bbb2.jpg";